/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CacheRefreshCommand } from '../models/cache-refresh-command';

@Injectable({
  providedIn: 'root',
})
export class SystemConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation signalCacheRefresh
   */
  static readonly SignalCacheRefreshPath = '/configuration/cache/reload';

  /**
   * Refresh all cached configuration. Noted that this will signal all the instances of CarefinDr API.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signalCacheRefresh()` instead.
   *
   * This method doesn't expect any request body.
   */
  signalCacheRefresh$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CacheRefreshCommand>> {

    const rb = new RequestBuilder(this.rootUrl, SystemConfigurationService.SignalCacheRefreshPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CacheRefreshCommand>;
      })
    );
  }

  /**
   * Refresh all cached configuration. Noted that this will signal all the instances of CarefinDr API.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `signalCacheRefresh$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  signalCacheRefresh(params?: {
  },
  context?: HttpContext

): Observable<CacheRefreshCommand> {

    return this.signalCacheRefresh$Response(params,context).pipe(
      map((r: StrictHttpResponse<CacheRefreshCommand>) => r.body as CacheRefreshCommand)
    );
  }

}
